import { signal } from '@preact/signals-react'

export const ephemeralUserListSignal = signal([])
export const ephemeralUserListLoadedSignal = signal(false)
export const ephemeralUserListErrorSignal = signal(null)

// system users
export const systemUserListSignal = signal([])
export const systemUserListLoadedSignal = signal(false)
export const systemUserListErrorSignal = signal(null)

// non-system users only
export const userListSignal = signal([])
export const userListLoadedSignal = signal(false)
export const userListErrorSignal = signal(null)

// to be used when loading an individual profile in the Administration/Users pages
export const userSignal = signal([])
export const userLoadedSignal = signal(false)
export const userErrorSignal = signal(null)

export const userGroupsSignal = signal([])
export const userGroupsLoadedSignal = signal(false)
export const userGroupsErrorSignal = signal(null)

export const userRolesSignal = signal([])
export const userRolesLoadedSignal = signal(false)
export const userRolesErrorSignal = signal(null)

export const userPermissionsSignal = signal([])
export const userPermissionsLoadedSignal = signal(false)
export const userPermissionsErrorSignal = signal(null)

// contains profile of the currently logged in user
export const currentUserSignal = signal([])
export const currentUserLoadedSignal = signal(false)
export const currentUserErrorSignal = signal(null)